import React from 'react';
import { Grid, Card } from '@mui/material';
import MDBox from 'components/MDBox';
import ComplexStatisticsCard from 'examples/Cards/StatisticsCards/ComplexStatisticsCard';

function ActiveProductionsSummary({ activeProductions }) {
    let totalProductions = activeProductions.length;

    // Count productions without statuses
    let noStatusCount = activeProductions.reduce((count, production) => {
        if (!production.status) {
            return count + 1;
        }
        return count;
    }, 0);

    // Calculate production health based on filled fields
    function getProductionHealth(production) {
        let { status, responsibles } = production;

        let fieldCount = 2; // Total fields to check
        let points = 0; // Initial points

        // Check if status is properly set
        if (status && typeof status === 'object' && Object.keys(status).length > 0) points += 1;

        // Check if responsibles are set
        if (Array.isArray(responsibles) && responsibles.length > 0) points += 1;

        // Calculate health score
        let healthScore = points / fieldCount;
        return healthScore;
    }

    // Calculate overall health
    let totalHealth = activeProductions.reduce((total, production) => total + getProductionHealth(production), 0);
    let overallHealth = totalProductions > 0 ? (totalHealth / totalProductions) * 100 : 0;

    // Get active production count where isActive is true
    const activeCount = activeProductions.filter((production) => production.isActive).length;

    // Get production count with no status
    const noStatus = noStatusCount;

    // Get count of productions linked to projects
    const linkedToProjects = activeProductions.reduce((count, production) => {
        return count + (production.projects && production.projects.length > 0 ? 1 : 0);
    }, 0);

    return (
        <Card>
            <MDBox p={3}>
                <Grid container spacing={3}>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3
                        }}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                color="dark"
                                icon="factory"
                                title="Aktif Üretim"
                                count={totalProductions}
                                percentage={{
                                    color: 'success',
                                    amount: `${activeCount} üretim aktif durumda`,
                                    label: '',
                                }}
                            />
                        </MDBox>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3
                        }}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                color={overallHealth > 70 ? 'success' : overallHealth > 40 ? 'warning' : 'error'}
                                icon="settings"
                                title="Üretim Sağlığı"
                                count={`${Math.round(overallHealth)}%`}
                                percentage={{
                                    color: 'secondary',
                                    amount: '',
                                    label: 'Genel üretim doluluk oranı',
                                }}
                            />
                        </MDBox>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3
                        }}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                color={noStatus === 0 ? 'success' : 'warning'}
                                icon="error"
                                title="Durum Girilmemiş"
                                count={noStatus}
                                percentage={{
                                    color: 'success',
                                    amount: '',
                                    label: 'Durumu belirtilmemiş üretimler',
                                }}
                            />
                        </MDBox>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3
                        }}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                color="info"
                                icon="work"
                                title="Projeye Bağlı"
                                count={linkedToProjects}
                                percentage={{
                                    color: 'success',
                                    amount: '',
                                    label: 'Bir projeye bağlı üretimler',
                                }}
                            />
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </Card>
    );
}

export default ActiveProductionsSummary;
